// Batch AT Stage C — online wizard for the Checkliste GW/TF.
//
// Underscore suffix on the parent segment (`dokumente_`) tells TanStack
// Router to NOT nest this route under the `dokumente.tsx` layout —
// the URL stays /dokumente/checkliste but the wizard renders as a
// standalone page instead of inside a non-existent <Outlet/> on the
// parent. Pre-fix the wizard never appeared because the parent route
// component didn't render an Outlet.

import { createFileRoute } from '@tanstack/react-router';
import { ChecklisteWizard } from '@/components/dokumente/ChecklisteWizard';

export const Route = createFileRoute('/_app/dokumente_/checkliste')({
  component: ChecklisteWizard,
});
